import React from 'react';
import CallResultBox from './ResultBox';
import { ACTIVITY_TYPES_ICONS } from '../../../Utils/constants/activityTypes';
import Dialog from '../../../Components/Dialog';

const InboundCallDialog = function InboundCallDialog({
  open,
  onClose,
  isOperator,
  phoneNumber,
  campaignId,
  onSubmit,
  fullScreen = false,
}) {
  const Icon = ACTIVITY_TYPES_ICONS.CALL;

  return (
    <Dialog
      id="inbound-dialog"
      title="INBOUND_CALL"
      icon={<Icon />}
      open={open}
      onClose={onClose}
      width="sm"
      fullWidth
      fullScreen={fullScreen}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <CallResultBox
        isOperator={isOperator}
        answered={true}
        phoneNumber={phoneNumber}
        campaignId={campaignId}
        handleEndCall={onSubmit}
      />
    </Dialog>
  );
};
export default InboundCallDialog;
